import React, { FC } from 'react';
import type { ISpAuthorizationToken } from 'ts/client/common';
import HomePageTitle from 'ts/common/components/gallery/HomePageTitle';
import type { ICoverPhoto } from 'ts/common/types';
import CoverSlideshowHeaderGate from './CoverSlideshowHeaderGate';

interface Props {
    albumCount?: number;
    coverPhoto?: ICoverPhoto;
    headingText: string;
    isLargeScreen?: boolean;
    /** Reports the header ready to render its final state — see `CoverSlideshowHeaderGate`. */
    onCoverSlideshowReady?: () => void;
    photoCount: number;
    spAuthorizationToken: ISpAuthorizationToken;
    spEventBus: SpAngularJs.ISpEventBus;
    translateFilter: SpAngularJs.ITranslateFilter;
}

/**
 * Wraps `HomePageTitle` in `CoverSlideshowHeaderGate` so a slideshow gallery cover plays inside
 * the gallery home page's header the same way it already plays as the gallery's intro
 * background. No `albumId` to pass through — the gallery home header's cover is scoped to the
 * whole event, not any one album.
 *
 * Kept out of `HomePageTitle` itself (and therefore out of `ts/common/components/gallery`, which
 * Studio's `GalleryPreview` also renders) so that client-only plumbing doesn't leak into a
 * component Studio's branding preview relies on rendering with no client-gallery services at all.
 */
const GalleryHomePageTitle: FC<Props> = ({
    coverPhoto,
    onCoverSlideshowReady,
    spAuthorizationToken,
    spEventBus,
    ...pageTitleProps
}) => (
    <CoverSlideshowHeaderGate
        coverPhoto={coverPhoto}
        onCoverSlideshowReady={onCoverSlideshowReady}
        spAuthorizationToken={spAuthorizationToken}
        spEventBus={spEventBus}
    >
        <HomePageTitle coverPhoto={coverPhoto} {...pageTitleProps} />
    </CoverSlideshowHeaderGate>
);

export default GalleryHomePageTitle;
